
  const { hot } = require("react-hot-loader/root")
  import Component from "/codebuild/output/src646894754/src/src/views/components/track-shipment-results/index.tsx"

  export default hot(Component)
  